import { AccountQuestionOutlineIcon } from './AccountQuestionOutlineIcon';

/**
 * author: Coffeemate
 * id C5217A29-708E-4340-AE2D-89A33F364A97
 * name account-question-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-question-outline.svg
 * tags
 * - Account / User 
 */
export const AccountQuestionMarkOutlineIcon = AccountQuestionOutlineIcon;
export default AccountQuestionMarkOutlineIcon